import { render, staticRenderFns } from "./DxDetailTabLocations.vue?vue&type=template&id=21306dbe&"
import script from "./DxDetailTabLocations.vue?vue&type=script&lang=js&"
export * from "./DxDetailTabLocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports